// Горизонт планирования каталога: на сколько дней вперёд витрина считает доступность.
// Источник — админ-настройки («Настройки → Общие → Горизонт планирования каталога»,
// GET /api/settings → catalog_horizon_days). У Стемса 14, у Букетберри 90 (24.09.2026).
//
// Раньше витрина в трёх местах держала 14 жёстко (пересчёт корзины, профиль букета в
// корзине, карточка букета в каталоге), хотя выбор даты на чекауте настройку уже читал.
// Пока горизонт у всех был 14, расхождения не было видно. При 90 чекаут предлагал бы дату
// поставки через месяц, а карточка букета её не видела и не давала положить товар в корзину.
//
// Значение читается один раз за сессию (общий транспорт settings.js) и дальше берётся из
// памяти: getCatalogHorizon — синхронно, для reconcileCart, который зовут обработчики.
import { useEffect, useState } from 'react';
import { fetchAppSettings, getAppSettingsCached, FOREVER } from './settings';

export const DEFAULT_HORIZON_DAYS = 14;

function parseHorizon(settings) {
  const value = Math.floor(Number(settings && settings.catalog_horizon_days));
  return Number.isFinite(value) && value > 0 ? value : DEFAULT_HORIZON_DAYS;
}

/** Последнее известное значение без ожидания сети (до первого ответа — дефолт). */
export function getCatalogHorizon() {
  const cached = getAppSettingsCached();
  return cached ? parseHorizon(cached) : DEFAULT_HORIZON_DAYS;
}

export function loadCatalogHorizon() {
  return fetchAppSettings({ maxAgeMs: FOREVER })
    .then(parseHorizon)
    .catch(() => DEFAULT_HORIZON_DAYS);
}

export function useCatalogHorizon() {
  const [horizon, setHorizon] = useState(getCatalogHorizon());
  useEffect(() => {
    let alive = true;
    loadCatalogHorizon().then((h) => { if (alive) setHorizon(h); });
    return () => { alive = false; };
  }, []);
  return horizon;
}
